import { getCookie, setCookie } from 'cor-business'

// Настройки, как и токены, храним в куках (см. cor-business/utils/cookie) — localStorage в проекте не используется.
export function readJsonCookie(name: string): Record<string, any> | null {
    try {
        const rawValue = getCookie(name)

        if (!rawValue) {
            return null
        }

        const parsedValue = JSON.parse(rawValue)

        if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) {
            return null
        }

        return parsedValue
    } catch (error) {
        return null
    }
}

export function writeJsonCookie(name: string, value: unknown, label: string) {
    try {
        setCookie(name, JSON.stringify(value))
    } catch (error) {
        console.error(`Failed to persist ${label}:`, error)
    }
}
